import { render, staticRenderFns } from "./tmOverlayBadge.vue?vue&type=template&id=e66146c0&"
import script from "./tmOverlayBadge.vue?vue&type=script&lang=js&"
export * from "./tmOverlayBadge.vue?vue&type=script&lang=js&"
import style0 from "./tmOverlayBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports